import WSMessage from './wsMessage';
import config from '../config';
import RestTransport from '../utils/transport';

class WSService {
  constructor() {
    this.StoreList = [];
    this.URL = config.API_URL5007 + '/websockets-service/v1';
    // this.URL = 'http://localhost:40050/api/websockets-service/v1';
  }
  ping() {
    ws.send('ping');
    tm = setTimeout(this.ping, 30000);
  }
  getStore(store) {
    for (let i = 0; i < this.StoreList.length; i++) {
      if (this.StoreList[i].store === store) return this.StoreList[i];
    }
    return null;
  }
  getToken(session) {
    let t = new RestTransport({
      baseURL: config.API_URL5007,
      timeout: 1000000,
      token: session.token,
      accountCode: session.accountCode,
      handleUnauthorized: session.handleUnauthorized,
      handleNetworkError: session.handleNetworkError,
      handleNetworkNotDown: session.handleNetworkNotDown,
    });
    let wsService = this;
    t.fetch(`${this.URL}/ws/GetToken`).then(
      function(promise) {
        let url = `${wsService.URL}/ws/Connect?token=${promise.data.token}`;
        url = url.replace('http', 'ws');
        wsService.ws = new WebSocket(url);
        wsService.ws.onmessage = message => {
          console.log('raw socket message ' + message.data);
          wsService.onMessage(JSON.parse(message.data));
          return false;
        };
        wsService.ws.onerror = error => {
          console.log('websocket error');
          console.log(error);
        };
        wsService.ws.onopen = () => {
          console.log('websocket open');
          // setInterval(this.ping, 30000);
        };
        wsService.ws.onclose = () => {
          console.log('websocket close');
        };
      },
      function(promise) {
        console.log('getting token for websocket failed');
      },
    );
  }
  onMessage(object) {
    let store = this.getStore(object.Store);
    if (store != null) {
      if (store.callback != undefined) store.callback(object);
    }
  }
  addListener(store, callback) {
    //console.log('store list');
    //console.log(this.StoreList);
    //console.log(store);
    for (let i = 0; i < this.StoreList.length; i++) {
      if (this.StoreList[i].store === store) {
        console.log('store ' + store + ' already registered');
        return;
      }
    }
    console.log('store registered: ' + store);
    this.StoreList.push({
      store: store,
      callback: callback,
    });
  }
}

class Singleton {
  constructor() {
    if (!Singleton.instance) {
      Singleton.instance = new WSService();
    }
  }

  getInstance() {
    return Singleton.instance;
  }
}

const s = new Singleton();

export default s.getInstance();
